import { get, isString } from 'lodash';

import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

import { RowEvent } from '../../models/row-event';
import { TableField } from '../../models/table-field';
import { TableItem } from '../../models/table-item';
import { AzTableService } from '../services/az-table.service';
import { TableRow } from '../../models/table-row';
import { TableAction } from '../../models/table-action';
import { TableActionEvent } from '../../models/table-action-event';
import { Router } from '@angular/router';

@Component({
  selector: '[az-table-body]',
  templateUrl: './az-table-body.component.html'
})
export class AzTableBodyComponent {
  public readonly BASE_TRANSALATE = 'shared.table';

  @Input() public actionable: boolean = false;
  @Input() public scrollable: boolean = false;

  @Input() public bodyTemplate!: TemplateRef<any>;
  @Input() public emptyTemplate!: TemplateRef<any>;
  @Input() selectMode: string = "multiple";
  @Input() public actions: Array<TableAction> | null = null;
  @Input() public fields: Array<string | TableField> | null = null;
  @Input() public rows: Array<TableRow> = [];
  @Input() public selectable: boolean = false;
  @Input() public idTable: string = "";
  @Output() public rowSelected = new EventEmitter<RowEvent>();
  @Output() public rowUnselected = new EventEmitter<RowEvent>();
  @Output() actionClick = new EventEmitter<TableActionEvent>();

  public pxMenos: number = 0;
  public widthMenos: number = 0;

  constructor(private tableService: AzTableService, private __router: Router) {
    this.calcWidthTableTH();
  }

  calcWidthTableTH() {
    let cW = 0;
    this.pxMenos = this.pxMenos + (this.selectable ? 50 : 0);
    this.pxMenos = this.pxMenos + (this.actionable ? 200 : 0);

    if (this.fields) {
      this.fields.forEach((c: any) => {
        if (c.width) {
          cW++;
          this.widthMenos = cW;
          this.pxMenos = this.pxMenos + parseInt(c.width.replace('px', ''));
        }
      });
    }
  }

  public getCellValue(item: any, field: string | TableField): any {
    let path = '';
    if (this.tableService.isTableField(field)) {
      path = field.key;
    } else if (isString(field)) {
      path = field;
    }
    return get(item, path, '');
  }

  public getCellClass(field: string | TableField): string | Array<string> {
    let result: Array<any> = [];
    if (this.tableService.isTableField(field)) {
      if (field.class) {
        result.push(...(isString(field.class) ? [field.class] : field.class));
      }
      if (field.tdClass) {
        result.push(...(isString(field.tdClass) ? [field.tdClass] : field.tdClass));
      }
    }
    return result;
  }

  public getIsEditable(field: string | TableField): boolean {
    if (this.tableService.isTableField(field)) {
      return field.editable ? field.editable : false;
    }
    return false;
  }

  geLINKBoolean(field: TableField | any, row: any): boolean {
    if (get(field, "link", "")) {
      return row[`link_${field.key}`] ? true : false;
    } else {
      return false;
    }
  }
  public goLink(field: TableField | any, row: any): void {
    if (get(field, "link", "")) {
      this.__router.navigateByUrl(row[`link_${field.key}`]);
    }
  }

  public getColspan(): number {
    let cFields = 0;
    let cAction = this.actionable ? 1 : 0;
    let cSelect = this.selectable ? 1 : 0;

    if (this.fields) {
      cFields = this.fields.length;
    }

    return cFields + cAction + cSelect;
  }

  onChangeTableEditable(e: any, item: any, field: any) {
    if (e.target) {
      if (e.target.nodeName != 'SELECT') {
        item[field.key] = e.target.value;
      }
    } else {
      item[field.key] = e;
    }
  }

  public getProperties(object: any): TableItem[] {
    let result: TableItem[] = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        const element = object[key];
        result.push(new TableItem(key, element));
      }
    }
    return result;
  }

  getHTMLBoolean(field: string | TableField) {
    return get(field, "html", "");
  }

  public isCheckbox(row: any): boolean {
    return row.item ? get(row.item, 'check', true) : true;
  }

  public actionClicked(action: TableAction, row: TableRow) {
    this.actionClick.emit({ action, row } as TableActionEvent);
  }

  public getStyles(field: string | TableField) {
    let widthX = get(field, 'width', '');
    let textAlignX = get(field, 'textAlign', '');
    let lengthField = 0;
    let obj = {
      width: '',
      textAlign: ''
    };

    if (this.fields) {
      lengthField = this.fields.length;
    }

    if (widthX != '') {
      obj.width = widthX ? widthX : 'calc(' + 100 / (lengthField - this.widthMenos) + '% - ' + this.pxMenos + 'px)';
    }

    if (textAlignX != '') {
      obj.textAlign = textAlignX;
    }

    return obj;
  }

  public selectRow(item: any, index: number) {
    this.rowSelected.emit({ index, item } as RowEvent);
  }

  public unselectRow(item: any, index: number) {
    this.rowUnselected.emit({ index, item } as RowEvent);
  }
}